<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Content Block</h1>
    </div>

    <div class="ui divider"></div>
    <form class="ui form grid segment" @submit.prevent="contentBlockUpdate">
      <div class="ui grid row stackable">
        <div class="eight wide column ">
          <label>Name</label>
          <input
            type="text"
            name="Name"
            placeholder=""
            v-model="name"
            :disabled="disabled"
            :class="{'disabled' : disabled}"
            class="field"
          />
        </div>
        <div class="eight wide column ">
          <label>Block Name (Generated from Name)</label>
          <input type="text" name="Name" placeholder="" v-model="niceBlockId" />
        </div>
        <div class="sixteen wide column">
          <label>Content</label>
          <froala
            id="edit"
            :config="config"
            v-model="Content"
            :tag="'textarea'"
          ></froala>
        </div>
        <div class="eight wide column">
          <div class="ui buttons">
            <button class="ui positive button">{{button}} Content Block</button>
            <div class="or"></div>
            <div class="ui light button" @click="$router.go(-1)">Cancel</div>
          </div>
        </div>
        <div class="eight wide column" v-if="this.deleteBtn">
          <div class="ui primary button right floated" @click="deleteModal">
            Delete Block
          </div>
        </div>
      </div>
    </form>
    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">
        Are you sure you want to delete this assembly?
      </div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">
          Nope
        </div>
        <div
          class="ui positive right labeled icon button"
          @click="contentBlockDelete"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
// import {config} from '@/assets/js/variables.js';

import SemanticModal from "vue-ya-semantic-modal";

export default {
  name: "EditContentBlock",
  computed: {},
  components: {
    SemanticModal: SemanticModal(),
  },
  data() {
    return {
      showModal: false,
      deleteBtn: false,
      name: "",
      niceBlockId: "",
      Content: "",
      active: false,
      disabled: false,
      error: "",
      button: "",
      title: "",
      // config: config
      config: {
        key: "YNB3fJ3C8C8A5A4C2A-9UJHAEFZMUJOYGYQEa1c1ZJg1RAeF5C4C3D3E2C2B4D6A3A1==",
        immediateVueModelUpdate: true,
        charCounterCount: true,
        placeholderText: "Edit Your Content Here!",
        fontSizeSelection: true,
        fontSize: ["8", "10", "12", "14", "18", "30", "60", "96"],
        toolbarButtons: {
          moreText: {
            buttons: [
              "html",
              "bold",
              "italic",
              "underline",
              "strikeThrough",
              "subscript",
              "superscript",
              "fontFamily",
              "fontSize",
              "textColor",
              "backgroundColor",
              "inlineClass",
              "inlineStyle",
              "clearFormatting",
            ],
          },
          moreParagraph: {
            buttons: [
              "alignLeft",
              "alignCenter",
              "formatOLSimple",
              "alignRight",
              "alignJustify",
              "formatOL",
              "formatUL",
              "paragraphFormat",
              "paragraphStyle",
              "lineHeight",
              "outdent",
              "indent",
              "quote",
            ],
          },
          moreRich: {
            buttons: [
              "insertLink",
              "insertImage",
              "insertVideo",
              "insertTable",
              "emoticons",
              "fontAwesome",
              "specialCharacters",
              "embedly",
              "insertFile",
              "insertHR",
            ],
          },
          moreMisc: {
            buttons: [
              "html",
              "undo",
              "redo",
              "fullscreen",
              "print",
              "getPDF",
              "spellChecker",
              "selectAll",
              "help",
            ],
            align: "right",
            buttonsVisible: 2,
          },
        },
      },
    };
  },
  mounted() {
    if (this.$route.params.id == undefined) {
      this.deleteBtn = false;
      this.disabled = false;
      this.button = 'Add';
      this.title = 'Add';
    } else {
      this.contentBlockDetails();
      this.deleteBtn = true;
      this.disabled = true;
      this.button = 'Save';
      this.title = 'Edit';
    }

  },
  methods: {
    deleteModal() {
      this.showModal = !this.showModal;
    },
    contentBlockDetails() {
      apiService
        .getContentBlockDetails({ id: this.$route.params.id })
        .then((request) => {
          this.contentBlockSuccessful(request);
        })
        .catch((err) => this.contentBlockFailed(err));
    },
    contentBlockSuccessful(request) {
      (this.name = request.name),
        (this.niceBlockId = request.niceBlockId),
        (this.Content = request.content),
        (this.active = request.active);
    },
    contentBlockFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    contentBlockUpdate() {
      if (this.$route.params.id == undefined) {
        // console.log(this.Content);

        apiService
          .createContentBlock({
            Name: this.name,
            content: this.Content,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.contentBlockSuccessful(request);
            this.$router.push("/admin/contentblocks/index");
          })
          .catch((err) => this.contentBlockFailed(err));
      } else {
        // console.log(this.content);
        apiService
          .updateContentBlock({
            id: this.$route.params.id,
            Name: this.name,
            content: this.Content,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.contentBlockSuccessful(request);
            this.$router.push("/admin/contentblocks/index");
          })
          .catch((err) => this.contentBlockFailed(err));
      }
    },
    contentBlockDelete() {
      // console.log('delete');

      apiService
        .deleteContentBlock({ id: this.$route.params.id })
        .then((request) => {
          this.contentBlockSuccessful(request);
          this.$router.push("/admin/contentblocks/index");
        })
        .catch((err) => this.contentBlockFailed(err));
    },
  },
};
</script>

<style module></style>
